import { createSlice } from '@reduxjs/toolkit';

interface FlowbuilderSlice {
  flowbuilder: {
    id: string;
    name?: string;
    flow?: string;
    workspaceId?: string;
    integrationType?: string;
    connectedChannelId?: string;
    isActive?: boolean;
  };
}

const initialState: FlowbuilderSlice = {
  flowbuilder: {
    id: '',
    name: '',
    flow: '',
    workspaceId: '',
    integrationType: '',
    connectedChannelId: '',
    isActive: false,
  },
};

export const flowbuilderSlice = createSlice({
  name: 'flowbuilder',
  initialState,
  reducers: {
    selectFlowbuilder: (state, { payload }) => {
      state.flowbuilder = { ...payload, header: {} };
    },
    resetFlowbuilder: (state) => {
      state.flowbuilder = initialState.flowbuilder;
    },
    setFlowbuilder: (state, action) => {
      state.flowbuilder = action.payload;
    },
    removeFlowbuilder: (state) => {
      state.flowbuilder = { id: '' };
    },
  },
});

export const {
  selectFlowbuilder,
  resetFlowbuilder,
  setFlowbuilder,
  removeFlowbuilder,
} = flowbuilderSlice.actions;

export default flowbuilderSlice.reducer;
